var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('vs-popup',{staticClass:"holamundo",attrs:{"title":"Network Connection Error","active":_vm.popUpNetwork},on:{"update:active":function($event){_vm.popUpNetwork=$event}}},[_c('p',[_vm._v("Internet Connection is Off")])]),_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }